import * as React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"

import { useSessionStore } from "features/Session"
import { DiscoverSpeakUpPage } from "features/Surveys"
import { PackageCode } from "models/generated"
import { ApplicationPath } from "./ApplicationNavigation"

export const SpeakUpPackageNotActivatedRoute: React.FunctionComponent<RouteProps> = (props) => {
  const customer = useSessionStore(state => state.customer)

  const isSpeakUpPackageEnabled = customer?.packages.some(
    (_package) => _package.codeName === PackageCode.Speakup && _package.isEnabled,
  )

  return (
    <Route
      {...props}
      render={() => isSpeakUpPackageEnabled
        ? <Redirect to={ApplicationPath.SpeakUpDashboard} />
        : <DiscoverSpeakUpPage/>
      }
    />
  )
}
